module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" I’m as nauseous as I’ve ever been. I have a terrible headache. My head is pounding. I feel like throwing up and I’m having trouble swallowing. And the beauty of it is, you want to feel like this every day.")])]), _c('blockquote', [_c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ONY")]), _vm._v(" L"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A")]), _vm._v(" R"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("USSA")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116f0f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 69
// module chunks = 0